
import React from 'react';
import Pushdown from '../components/Pushdown';
import Account from '../components/svgs/Account';
import { buildOAuthUrl } from '../helpers/switchAccount';
import { isAptEnabled } from '../helpers/auth';
import { ACCOUNT_SWITCHER, withQuery } from '../helpers/routes';

// Returns the URL for switching accounts based on APT availability
const getSwitchAccountUrl = () => {
  // When APT is enabled, use OAuth flow for account switching
  if (isAptEnabled()) {
    return buildOAuthUrl();
  }

  // When APT is disabled, redirect to the account switcher page with the current URL
  // as a continue param so the user is returned here after selecting an account
  const continueUrl = `${window.location.pathname}${window.location.search}`;
  return withQuery(ACCOUNT_SWITCHER, { continueUrl });
};

/**
* AccountInfoPushdown
*
* @param {Object} props
* @param {string} props.accountNumber - The last 4 account number.
* @param {boolean} props.hasLinkedAccounts - Whether the user has multiple linked accounts.
* @param {Object} props.serviceAddress
* @param {string} props.serviceAddress.addressLine1
* @param {string} props.serviceAddress.state
* @param {string} props.serviceAddress.zip
*/
const AccountInfoPushdown = ({ accountNumber, hasLinkedAccounts, serviceAddress = {} }) => {
  if (!isAptEnabled()) return null;

  return (
    <Pushdown icon={<Account />}>
      {Object.keys(serviceAddress).length ? (
        <strong data-notranslate>
          {`${serviceAddress.addressLine1}, ${serviceAddress.state} ${serviceAddress.zip}`}
        </strong>
      ) : null}
      {accountNumber && (<p>{`Account Number: ${accountNumber}`}</p>)}
      {hasLinkedAccounts && (
        <a
          className="link d-flex align-items-center"
          href={getSwitchAccountUrl()}
        >
          Switch account
        </a>
      )}
    </Pushdown>
  );
};

export default AccountInfoPushdown;
